export default function ScoreDistributionChart({ max=20,data=[] }) {

    const barWidth = 1000/max
    const mostAppearedScore =()=>{
        let dict={}
        for(let score of data){
            if(dict[score]){
                dict[score]++
            }else{
                dict[score]=1
            }
        }
        let max=0
        for(let key in dict){
            if(dict[key]>max){
                max=dict[key]
            }
        }
        return max
    }
    const getHorizontalLines=()=>{
        let MAX= mostAppearedScore()
        if(MAX<=5)return [1,2,3,4,5]
        if(MAX<=10)return [2,4,6,8,10]
        if(MAX<=20)return [5,10,15,20]
        if(MAX<=50)return [10,20,30,40,50]
        if(MAX<=100)return [20,40,60,80,100]
        if(MAX<=200)return [50,100,150,200]
        if(MAX<=500)return [100,200,300,400,500]
        return [200,400,600,800,1000]
    }
    const getHorizontalMax=()=>{
        let MAX= mostAppearedScore()
        if(MAX<=5)return 5
        if(MAX<=10)return 10
        if(MAX<=20)return 20
        if(MAX<=50)return 50
        if(MAX<=100)return 100
        if(MAX<=200)return 200
        if(MAX<=500)return 500
        return 1000
    }
    const getArray=()=>{
        return Array.from(Array(max+1).keys()).map((score)=> data.filter(i=>i===score).length)
    }
    return(
        <div className="w-full" style={{height:undefined,aspectRatio:1200/240,objectFit:'contain'}}>
            <svg width={'100%'} height={'100%'} viewBox="-100 0 1100 240">
                <defs>
                    <linearGradient id="polylineGradient" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#00E6BD80" stopOpacity="1" />
                        <stop offset="100%" stopColor="#ffffff00" stopOpacity="0.8" />
                    </linearGradient>
                </defs>
                <line x1="-100" y1="200" x2={1200} y2={200} stroke="grey" strokeWidth="2"/>

                {Array.from(Array(max+1).keys()).map((item,index)=>
                    <line key={index} x1={index*barWidth} y1="20" x2={index*barWidth} y2="200" stroke="grey" strokeWidth="1"/>
                )}

                {getHorizontalLines().map((item,index)=>
                    <line key={index} x1="-50" y1={200-(160/getHorizontalMax()*item)} x2={1000} y2={200-(160/getHorizontalMax()*item)} stroke="grey" strokeWidth="1"/>
                )}
                {getHorizontalLines().map((item,index)=>
                    <text key={index} x={-80} y={200-(160/getHorizontalMax()*item)} fill="grey" fontSize="14" textAnchor="end">{item}</text>
                )}
                {Array.from(Array(max+1).keys()).map((item,index)=>
                    <text key={index} x={item*barWidth} y="220" fill="black" fontSize="14" textAnchor="end">{item}</text>
                )}
                <text x={-80} y={20} fill="black" fontSize="14" fontWeight={700} textAnchor="end">學生</text>
                <text x={-80} y={220} fill="black" fontSize="14" fontWeight={700} textAnchor="end">分數</text>

                {getArray().map((item,index)=>
                    <rect key={index} x={index*barWidth-2} y={200-(160/getHorizontalMax()*item)} width={4} height={200-(200-(160/getHorizontalMax()*item))} fill="#9D00FF" />
                )}

                <polygon 
                    points={`-100,200 ${getArray().map((item,index,arr)=>{
                        if (index === 0 || index === arr.length - 1) {
                            return `${index*barWidth},${200-(160/getHorizontalMax()*item)}`;
                        }
                        const prev = arr[index - 1];
                        const next = arr[index + 1];
                        const smoothedY = (prev + item + next) / 3;
                        return `${index*barWidth},${200-(160/getHorizontalMax()*smoothedY)}`;
                    }).join(' ')} ${1000},200`} 
                    fill="url(#polylineGradient)" 
                    stroke="none" 
                />
                <polyline points={'-100,200 '+getArray().map((item,index,arr)=>{
                    if (index === 0 || index === arr.length - 1) {
                        return `${index*barWidth},${200-(160/getHorizontalMax()*item)}`;
                    }
                    const prev = arr[index - 1];
                    const next = arr[index + 1];
                    const smoothedY = (prev + item + next) / 3;
                    return `${index*barWidth},${200-(160/getHorizontalMax()*smoothedY)}`;
                }).join(' ')} fill="none" stroke="#00E6BD80" strokeWidth="2" />
            </svg>
        </div>
    )
}